import React from "react";

import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const OurStoryScreen: React.FC = () => {
  const { t } = i18n;

  return (
    <Container fluid style={{ backgroundColor: "var(--bg-light-color)" }}>
      <Container
        className="flexContainer text-center text-lg-start"
        style={{ paddingBottom: "3rem" }}
      >
        <div className="d-flex flex-column flex-lg-row align-items-center gap-5">
          <div className="flexContainer mb-4 flex-grow-0 flex-basis-50">
            <Image
              rounded
              alt={`PakVille ${t("our_story")}`}
              className="mw-100"
              src="/images/story/our-story.png"
            />
          </div>

          <div className="flexContainer flex-grow-0 flex-basis-50">
            <Row className="mb-5">
              <Col xs={12}>
                <h2 className="itemHeader">{t("our_story")}</h2>

                <p>
                  {t(
                    "At PakVille, we believe in building a sustainable future, one neighbourhood at a time. We were founded to rethink the way buildings are made, making construction faster, more affordable, and environmentally responsible without sacrificing quality or performance.",
                  )}
                </p>

                <p>
                  {t(
                    "Traditional construction is slow, costly, and resource-intensive. We asked: What if we could design a better way? That question led to the creation of PakVert engineered panels: an all-in-one building system made from 100 % recycled materials that replaces conventional layers like framing, insulation, vapor barriers, drywall, and exterior sheathing.",
                  )}
                </p>

                <p>
                  {t(
                    "Our team brings together engineering, fabrication, and construction expertise to deliver turnkey modular buildings that meet real-world needs, from single-family homes and modular housing to multi-storey residential, commercial, and community buildings.",
                  )}
                </p>

                <p>
                  {t(
                    "Today, PakVille works with public and private partners across multiple markets to deliver efficient, high-performance buildings that reduce waste, speed up construction timelines, and make sustainable living more accessible.",
                  )}
                </p>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default OurStoryScreen;
